Object.defineProperty(exports,"__esModule",{value:true});exports.default=void 0;var borderWidths={'0':0,'1':'1px','2':'2px','4':'4px','8':'8px'};var _default=borderWidths;exports.default=_default;
//# sourceMappingURL=borders.js.map